module.exports = __webpack_public_path__ + "img/control.9aa94cf2.svg";